export default __webpack_public_path__ + "static/media/Whitepaper.9592d4af.pdf";